import * as preact from "preact";

/**
 * Where translated words will show (Words, Practice) before there are any:
 * what will appear, and a way to the Library to start reading.
 */
export default class ReadFirstHintView extends preact.Component<{
  children: preact.ComponentChildren;
}> {
  render() {
    return (
      <div class="readFirstHint">
        <img
          class="readFirstHintRabbit"
          src="/content/landingPages/rabbit-reading.webp"
          alt=""
        />
        <p>{this.props.children}</p>
        <a class="payButton" href="/library">
          Find something to read
        </a>
      </div>
    );
  }
}
